<template>
  <AppPage class="order-page">
    <AppHeader
        title="MI PEDIDO"
        right-icon="paper-plane"
        :left-action="onBack"
        :right-action="sendOrder"
        hideNumber
    />
    <template v-if="order.length > 0">
      <AppSection>
        <OrderDetails
            :location="location"
            :order="order"
            @sendOrder="sendOrder"
            editable
        />
      </AppSection>
      <AppSection title="PRODUCTOS">
        <OrderProduct
            v-for="product in order"
            :key="product.key"
            :product="product"
            @add="productUds(product,  1)"
            @del="productUds(product, -1)"
            @deleteProduct="deleteProduct"
            editable
        />
      </AppSection>
    </template>
    <AppSection v-else>
      <div class="alert alert-info text-center">
        <i class="fa fa-exclamation-triangle" />
        <p>NO SE ENCONTRARON ARTICULOS EN EL PEDIDO.</p>
        <button class="btn btn-info" @click="goToCatalog">MOSTRAR CATALOGO</button>
      </div>
    </AppSection>
  </AppPage>
</template>
<script>
import { orderBy } from 'lodash'
import { usersRef } from '../firebase'
import OrderDetails from '../components/Order/OrderDetails'
import OrderProduct from '../components/Order/OrderProduct'

export default {
  components: { OrderDetails, OrderProduct },
  data() {
    return {
      location: {}
    }
  },
  mounted() {
    const user = this.$store.getters.user
    const order = this.$store.getters.order
    const order_location = this.$store.getters.order_location
    if (!user) this.$router.push('/')
    else if (!order || order.length === 0) this.$router.push('/catalog')
    else this.location = order_location
  },
  computed: {
    order() {
      const profile = this.$store.state.profile
      const order = profile.order
        ? Object.keys(profile.order).map(i => ({
            key: i,
            ...profile.order[i]
          }))
        : []
      return orderBy(order).reverse()
    }
  },
  methods: {
    productUds(product, uds) {
      const uid = this.$store.state.profile.user.uid
      const orderRef = usersRef.child(uid).child('order')
      orderRef.once('value', snap => {
        const orderValue = snap.val()
        const orderEntries = Object.entries(orderValue)
        orderEntries.forEach(p => {
          const key = p[0]
          const pro = p[1]
          if (pro.CODARTICULO === product.CODARTICULO) {
            const newUds = (pro.UDS += uds)
            if (newUds > 0) orderRef.child(key).set({ ...pro, UDS: newUds })
            else this.deleteProduct(product)
          }
        })
      })
    },
    goToCatalog() {
      this.$router.push('/catalog')
    },
    async deleteProduct(product) {
      const uid = this.$store.state.profile.user.uid
      const key = product.key
      const res = await window.confirm(
        `Borrar el producto ${product.DESCRIPCION}`
      )
      if (res) {
        await usersRef
          .child(uid)
          .child('order')
          .child(key)
          .remove()
          .catch(console.error)
        this.$toasted.error(
          `SE BORRÓ ${product.DESCRIPCION.toUpperCase()} DEL PEDIDO`,
          { fullWidth: true, icon: { name: 'trash-alt' } }
        )
      }
    },
    async sendOrder() {
      this.$router.push('/send-order')
    },
    onBack() {
      this.$router.push('/catalog')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Order.vue